export default "__VITE_ASSET__5a18dc73__"